import React from 'react';
import { Container } from 'react-bootstrap';
import Title from './shared/Title';

const About = () => {
  return (
    <section id="about">
      <Container>
        <div className="project-wrapper">
          <br />
          <Title title="About" />
          <br />
          <p style={{ textAlign: 'left' }}>
            Standing at 19,341 feet above sea level at the Uhuru Peak, Mount Kilimanjaro is the highest mountain on the African continent and the highest single free-standing mountain in the world. Located in northwestern Tanzania, "Kili" is a stratovolcano with three separate cones: Kibo, which is dormant and houses the Uhuru Peak, as well as Mawenzi and Shira, which are both extinct. 
          </p>
          <br />
          <p style={{ textAlign: 'left' }}>
            We'll be ascending appx 16,000 feet over 8 days via the Lemosho Route, a 45-mile trek through jungle, rain forest, alpine desert, and over arctic snow and ice at the summit.
          </p>
          <br />
          <p style={{ textAlign: 'left' }}><span style={{ fontWeight: 700 }}>
            In 2019, the 8-member Kilimanjaro Climb  team collectively raised more than $92,000 in support of the American Cancer Society.</span>
          </p>
          <br />
          <p style={{ textAlign: 'left' }}>
            In August 2021, I'll be climbing with a team of 5 others from around the U.S. 
          </p>
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </Container>
    </section>
  );
};

export default About;
